import React from 'react';
import { useCompany, updateUser, useCompanyUsers, updateCompany, useInvites, useSubscription, useInvoices, cancelSubscription } from 'api';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { Loading, Title, Text, Card, Button, Checkbox, Input } from 'ui';
import moment from 'moment';
import "./index.css";

export default function Company() {
  
  const history = useHistory();
  const {params:{ companyId }} = useRouteMatch();
  const company = useCompany(companyId);
  const users = useCompanyUsers(companyId);
  const invites = useInvites(companyId);
  const subscription = useSubscription(companyId);
  const invoices = useInvoices(companyId);
  
  if(!company || !users || !invites) {
    return <Loading/>;
  }
  
  const roleClickHandler = user => () => {
    if(user.role === "COMPANY_ADMIN") {
      updateUser(user.id, {role:"CONTRIBUTOR"});
    }
    else { 
      updateUser(user.id, {role:"COMPANY_ADMIN"});
    }
  };
  
  async function cancel() {
    await cancelSubscription(companyId);
    history.push('/');
  }
  
  return (
    <div className="company">
      <Title>{company.name}</Title>
      <section className="company-info">
      
        <Card>
          <Text block style={{marginBottom:8}}>{company.name}</Text>
          <Text small block>{company.email}</Text>
          <Text small block>{company.street}</Text>
          <Text small block>{company.city} {company.state} {company.zip}</Text>
          <br/>
          <Button label="Edit" to="edit"/>
        </Card>
        
        <Card>
          {subscription === null ? (
            <Text small block>Loading...</Text>
          ) : (
            <div>
              <Text block style={{marginBottom:8}}>{subscription.plan}</Text>
              {subscription.amount && <Text small block>Paying ${subscription.amount/100}/month</Text>}
              {subscription.next && <Text small block>Next payment due on {moment(subscription.next).format("dddd, MMMM Do YYYY")}.</Text>}
              {subscription.cc && <Text small block>Paying by credit card: XXXX XXXX XXXX {subscription.cc}</Text>}
              <br/>
              <Button label="Payment Details" to="payment" style={{marginRight:4}}/>
              <Button label="Change Plan" to="plan"/>
            </div>
          )}
        </Card>
        
      </section>
      
      <Title>Users</Title>
      <section>
        {users.map(user => 
          <Card key={user.id} className="company-user">
            <div className="company-user-info">
              <Text block className="company-user-name">{user.displayName}</Text>
              <Text block small className="company-user-email">{user.email}</Text>
              <div className="company-user-role">
                <Checkbox 
                  small label="Company Admin" 
                  checked={user.role === "COMPANY_ADMIN" || user.role === "ADMIN"}
                  onClick={roleClickHandler(user)}
                />
              </div>
            </div>
            <div className="company-user-actions">
              <Button to={`remove-user/${user.id}`} style={{width:80}}>Remove</Button>
            </div>
          </Card>
        )}
        {invites.map(invite => 
          <Card key={invite.id} className="company-user">
            <div className="company-user-info">
              <Text block className="company-user-name">{invite.email}</Text>
              <Text block small className="company-user-email">Invited {moment(invite.dateSent).format("MM/DD/YYYY")}</Text>
              <div className="company-user-email"/>
            </div>
            <div className="company-user-actions">
              <Button to={`remove-invite/${invite.id}`} style={{width:80}}>Revoke</Button>
            </div>
          </Card>
        )}
        <Button label="Invite Contributor" className="company-invite" to="invite-user"/>
      </section>
      
      <Title>Google Analytics Code</Title>
      <section>
        <Input
          inputStyle={{padding:"12px 16px"}}
          placeholder="UA-XXXXXXXXX-X"
          value={company.gaCode}
          onChange={gaCode => updateCompany(companyId, {gaCode})}
        />
      </section>
      
      <Title>Discount Code</Title>
      <section>
        <Input
          inputStyle={{padding:"12px 16px"}}
          placeholder=""
          value={company.discountCode}
          onChange={discountCode => updateCompany(companyId, {discountCode})}
        />
      </section>
      
      <Title>Invoices</Title>
      <section>
      {invoices ? (
        invoices.map(invoice => 
          <Card key={invoice.url} className="company-invoice">
            <div className="company-invoice-info">
              <Text block className="company-invoice-reason">{invoice.reason}</Text>
              <Text block className="company-invoice-amt">${invoice.amount/100}</Text>
              <Text block className="company-invoice-date">{moment(invoice.date).format("MM/DD/YYYY")}</Text>
            </div>
            <div className="company-invoice-actions">
              <Button style={{width:80}}>
                <a href={invoice.url} target="_blank" rel="noopener noreferrer">Download</a>
              </Button>
            </div>
          </Card>
        )
      ) : (
        <Text small block>Loading...</Text>
      )}
      </section>
      
      <section>
        <Button label="Cancel Subscription" className="company-invite" onClick={cancel}/>
      </section>
    </div>
  );
}